// src/components/ConfirmModal.js
// Replacement for window.confirm(). Render it when a confirm state is set:
//   const [confirm, setConfirm] = useState(null); // { message, onConfirm, confirmLabel? }
//   <button onClick={() => setConfirm({ message: 'Delete?', onConfirm: doDelete })}>
//   {confirm && <ConfirmModal {...confirm} onCancel={() => setConfirm(null)} />}

import React from 'react';

export default function ConfirmModal({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = true, dir, onConfirm, onCancel }) {
  const run = () => { onCancel(); onConfirm(); };
  return (
    <div dir={dir} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:2000,padding:16}}>
      <div className="card" style={{width:420,maxWidth:'100%'}}>
        {title && <div style={{fontWeight:700,marginBottom:6}}>{title}</div>}
        <div style={{fontSize:13,color:'var(--text2)',marginBottom:16}}>{message}</div>
        <div style={{display:'flex',gap:8}}>
          <button className={`btn btn-sm ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={run} autoFocus>{confirmLabel}</button>
          <button className="btn btn-sm" onClick={onCancel}>{cancelLabel}</button>
        </div>
      </div>
    </div>
  );
}
